import { MenuItem, styled } from '@mui/material';
import { GridDensity } from '@mui/x-data-grid';
import { useSuppliersTFunction } from '@retail/suppliers/i18n';
import { Dispatch, SetStateAction, useState } from 'react';
import TableRowsIcon from '@mui/icons-material/TableRows';
import ViewHeadlineIcon from '@mui/icons-material/ViewHeadline';
import ViewStreamIcon from '@mui/icons-material/ViewStream';
import { Menu, MenuButton } from '@retail/components';

interface Props {
  gridDensity: GridDensity;
  setGridDensity: Dispatch<SetStateAction<GridDensity>>;
}

export const SuppliersDensityMenu = ({ gridDensity, setGridDensity }: Props) => {
  const t = useSuppliersTFunction();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClose = () => setAnchorEl(null);

  const handleSetDensity = (density: GridDensity) => {
    setGridDensity(density);
    handleClose();
  };

  return (
    <Menu>
      <MenuButton
        size="small"
        id="density-button"
        aria-controls={open ? 'density-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        sx={{
          color: 'grey.800',
          boxShadow: 'none',
          backgroundColor: 'transparent',
        }}
      >
        <TableRowsIcon sx={{ mr: 1 }} />
        {t('suppliers.density')}
      </MenuButton>

      <StyledMenuItem
        onClick={() => handleSetDensity('compact')}
        selected={gridDensity === 'compact'}
        hasBorderTop={false}
      >
        <ViewHeadlineIcon /> {t('suppliers.compact')}
      </StyledMenuItem>
      <StyledMenuItem
        onClick={() => handleSetDensity('standard')}
        selected={gridDensity === 'standard'}
      >
        <TableRowsIcon /> {t('suppliers.standard')}
      </StyledMenuItem>
      <StyledMenuItem
        onClick={() => handleSetDensity('comfortable')}
        selected={gridDensity === 'comfortable'}
      >
        <ViewStreamIcon /> {t('suppliers.comfortable')}
      </StyledMenuItem>
    </Menu>
  );
};

const StyledMenuItem = styled(MenuItem, {
  shouldForwardProp: (prop) => prop !== 'hasBorderTop',
})<{ hasBorderTop?: boolean }>(({ theme, hasBorderTop = true }) => ({
  width: 220,
  color: theme.vars.palette.grey[800],
  borderTop: hasBorderTop ? undefined : 'none',

  '.MuiSvgIcon-root': {
    fill: theme.vars.palette.grey[800],
  },
}));
